exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--2-1!normalize.css"), "");

// module
exports.push([module.id, "html {\n  min-height: 100%;\n  height: 100%;\n  position: relative;\n}\n\nbody  {\n  background: #fff;\n  overflow: hidden;\n  min-height: 100%;\n  height: 100%;\n  position: relative;\n}\n\n#root {\n  background: #f7f7f7;\n  display: flex;\n  height: 100%;\n  overflow: auto;\n}\n\n._38U0MsNN {\n  width: 100%;\n  flex: 1;\n  display: flex;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  text-decoration-skip: ink;\n  text-decoration-skip-ink: auto;\n  color: #be1780;\n}\n\nol, ul {\n  padding: 0 0 0 2em;\n  margin: 0;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  display: none;\n  -webkit-appearance: none;\n}\n\ninput[type='number'] {\n  -moz-appearance:textfield;\n  -webkit-appearance:textfield;\n}\n\ncode, pre {\n  font-family: \"Roboto Mono\", monospace;\n}\n\n@media print {\n  html, body {\n    width: 8.5in;\n  }\n\n  #root {\n    color: red;\n    background: #fff;\n  }\n\n  .hidden-print {\n    display: none;\n  }\n}\n\n@page {\n  size: letter;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_38U0MsNN"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../ui-kit/src/components/base.css
// module id = 479
// module chunks = 1